module.exports = __webpack_public_path__ + "img/file-earmark-play.f4af95e3.svg";